import React from "react";
import { Loader2, VideoOff, AlertTriangle } from "lucide-react";

// Shown for a video that doesn't yet have a bf H.264 URL. We deliberately do NOT
// render the raw uploaded .mov here — iPhone HEVC is undecodable in most browsers.
// `failed` switches to an "unavailable" state so a broken video never spins forever.
export const VideoProcessing = ({ className = "", compact = false, failed = false, stalled = false, stage = null }) => (
  <div
    data-testid={failed ? "video-failed" : stalled ? "video-stalled" : "video-processing"}
    className={`absolute inset-0 flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-secondary/70 to-black text-muted-foreground ${className}`}
  >
    {stalled && !failed ? (
      <>
        <AlertTriangle className={`text-amber-400 ${compact ? "w-4 h-4" : "w-6 h-6"}`} />
        {!compact && <span className="text-[11px] tracking-wide uppercase text-amber-300">Processing stalled</span>}
        {!compact && stage && <span className="text-[10px] text-muted-foreground">last stage: {stage}</span>}
      </>
    ) : failed ? (
      <>
        <VideoOff className={`text-muted-foreground ${compact ? "w-4 h-4" : "w-6 h-6"}`} />
        {!compact && <span className="text-[11px] tracking-wide uppercase">Original saved · processing failed</span>}
      </>
    ) : (
      <>
        <Loader2 className={`animate-spin text-primary ${compact ? "w-4 h-4" : "w-6 h-6"}`} />
        {!compact && <span className="text-[11px] tracking-wide uppercase">Processing video…</span>}
      </>
    )}
  </div>
);
